module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921095649_T.2d1cedd6.jpg";